import { useCallback, useRef, useState } from "react";

/**
 * Ignores stale async responses when a newer list/filter request has started.
 * Use one instance per table data source (share across filter, search, and default fetches).
 *
 * `loadFailed` is true while the latest request failed, so the table can warn
 * that the rows on screen are left over from an earlier load.
 */
export function useLatestRequestGuard() {
  const latestIdRef = useRef(0);
  const [loadFailed, setLoadFailed] = useState(false);

  const beginRequest = useCallback(() => {
    latestIdRef.current += 1;
    return latestIdRef.current;
  }, []);

  const isLatestRequest = useCallback((requestId: number) => {
    return requestId === latestIdRef.current;
  }, []);

  return { beginRequest, isLatestRequest, loadFailed, setLoadFailed };
}
